import TempoAPI from './TempoAPI'

export default class IssuesAPI extends TempoAPI {
    constructor() {
        super();
        this.serviceName = 'get_issues';
    }
    
    getIssues(handler) {
        const data = {};
        this.makeAPICall(this.serviceName, data, handler);
    }
}